import { render, staticRenderFns } from "./EventManagementModal.vue?vue&type=template&id=5ef87e9a&"
import script from "./EventManagementModal.vue?vue&type=script&lang=js&"
export * from "./EventManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./EventManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports